import React, { Component } from 'react';
import { MDBCarousel, MDBCarouselInner, MDBCarouselItem, MDBView, MDBContainer } from
"mdbreact";
import './Carousel.css'
import Tvs from '../images/Tvs.jpg'
import Macbook from '../images/MacBook.jpg'
import iPad from '../images/iPad.jpg'
import iPhone from '../images/iPhone.jpg'
import Banner from '../images/Banner.png'
import ps4 from '../images/ps4.jpg'

const BCarousel = () =>{
    return (
        <div>
            <MDBCarousel activeItem={1} length={6} interval={2000} showControls={false} showIndicators={false} className="z-depth-1" slide>
                <MDBCarouselInner>
                    <MDBCarouselItem itemId="1" className="carousel-item">
                        <MDBView>
                            <img className="d-block w-100" src={Banner} alt="" />
                        </MDBView>
                    </MDBCarouselItem>
                    <MDBCarouselItem itemId="2" className="carousel-item">
                        <MDBView>
                            <img className="d-block w-100" src={Tvs} alt="Second slide"/>
                        </MDBView>
                    </MDBCarouselItem>
                    <MDBCarouselItem itemId="3" className="carousel-item">
                        <MDBView>
                            <img className="d-block w-100" src={Macbook} alt="Third slide"/>
                        </MDBView>
                    </MDBCarouselItem>
                    <MDBCarouselItem itemId="4" className="carousel-item">
                        <MDBView>
                            <img className="d-block w-100" src={iPad} alt="Third slide"/>
                        </MDBView>
                    </MDBCarouselItem>
                    <MDBCarouselItem itemId="5" className="carousel-item">
                        <MDBView>
                            <img className="d-block w-100" src={iPhone} alt="Third slide"/>
                        </MDBView>
                    </MDBCarouselItem>
                    <MDBCarouselItem itemId="6" className="carousel-item">
                        <MDBView>
                            <img className="d-block w-100" src={ps4} alt="Third slide"/>
                        </MDBView>
                    </MDBCarouselItem>
                </MDBCarouselInner>
            </MDBCarousel>
        </div>
    );
}

export default BCarousel;